import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Medal, Loader2, CheckCircle2, XCircle, Home } from "lucide-react";
import { SiteLogo } from "@/components/SiteLogo";
import { BrandText } from "@/components/BrandText";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMessage("Link non valido: token mancante."); return; }
    api.post("/newsletter/unsubscribe", { token })
      .then(({ data }) => {
        localStorage.removeItem("gc_newsletter");
        setStatus("success");
        setMessage(data.email ? `${data.email} è stata rimossa dalla newsletter.` : "Iscrizione annullata correttamente.");
      })
      .catch((e) => {
        setStatus("error");
        setMessage(formatApiErrorDetail(e.response?.data?.detail));
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-6 noise-bg">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-8">
          <SiteLogo className="w-8 h-8" />
          <div className="flex flex-col leading-tight text-left">
            <BrandText />
          </div>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#0F172A] p-8 text-center" data-testid="unsubscribe-card">
          {status === "loading" && (
            <div className="py-6" data-testid="unsubscribe-loading">
              <Loader2 className="w-8 h-8 animate-spin text-gold mx-auto" />
              <p className="text-muted-foreground mt-4">Annullamento iscrizione in corso…</p>
            </div>
          )}
          {status === "success" && (
            <div className="py-6" data-testid="unsubscribe-success">
              <CheckCircle2 className="w-12 h-12 text-[#10B981] mx-auto" />
              <h1 className="font-display text-2xl mt-4">Iscrizione annullata</h1>
              <p className="text-muted-foreground mt-2">{message}</p>
              <p className="text-sm text-muted-foreground mt-1">Non riceverai più le nostre email. Ci dispiace vederti andare via!</p>
            </div>
          )}
          {status === "error" && (
            <div className="py-6" data-testid="unsubscribe-error">
              <XCircle className="w-12 h-12 text-destructive mx-auto" />
              <h1 className="font-display text-2xl mt-4">Operazione non riuscita</h1>
              <p className="text-muted-foreground mt-2">{message}</p>
            </div>
          )}
          <Link to="/" data-testid="unsubscribe-home-link" className="mt-6 inline-flex items-center gap-1.5 text-sm text-gold hover:text-[#FDE047] transition-colors">
            <Home className="w-3.5 h-3.5" /> Torna al sito
          </Link>
        </div>
      </div>
    </div>
  );
}
